import script from "./SectionTile.vue?vue&type=script&setup=true&lang=js"
export * from "./SectionTile.vue?vue&type=script&setup=true&lang=js"

import "./SectionTile.vue?vue&type=style&index=0&id=3f23cad8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f23cad8"]])

export default __exports__